/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-06 14:09:01
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-17 09:02:45
 */
/**
 * api接口统一管理
 */
// import axios from './http.js'
import index from './m/index.js'
import manager from './user/manager.js'
import common from './common/common.js'
import map from './m/map.js'
import user from './user.js'
import shop from './m/shop.js'
import address from './m/address.js'
import live from './m/live.js'
import my from './m/user.js'
import tradesman from './m/tradesman.js'
import seller from './m/seller.js'
import living from './m/living.js'
import xiaoxi from './m/xiaoxi.js'
import park from './m/park.js'
import dingzhi from './m/dingzhi.js'
import toutiao from './m/toutiao.js'
import history from './m/history.js'
import parkmall from './m/parkmall.js'
import blockchain from './m/blockchain.js'
import smartpark from './m/smartpark.js'
import xianli from './m/xianli.js'
import invoice from './m/invoice'
import zhuanti from './m/zhuanti.js'
import agent from './m/agent.js'
import salesman from './m/salesman.js'
import jinhe from './m/jinhe.js'
import thirdshop from './m/thirdshop.js'

const api = {
	thirdshop,
	jinhe,
	salesman,
	agent,
	zhuanti,
    common,
    index,
    map,
	manager,
	user,
    shop,
	address,
    live,
    living,
    my,
	dingzhi,
    seller,
	park,
	toutiao,
    history,
    xiaoxi,
	tradesman,
	parkmall,
    blockchain,
	smartpark,
	xianli,
    invoice
}

export default api
